import { r as registerInstance, h, H as Host } from './index-16dc7dde.js';
import { i as isV3, j as getBrandName } from './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import { c as createCommonjsModule, a as commonjsGlobal, g as getDefaultExportFromCjs } from './_commonjsHelpers-ba3f0406.js';
import { c as classnames } from './index-136476ff.js';
import { I as IconCopy } from './copy-d62b8b74.js';
import { N as NotificationBannerController } from './controller-0b53c447.js';
import './analytics-765d4daf.js';
import './utils-15ad90ec.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

var clipboard = createCommonjsModule(function (module, exports) {
/*!
 * clipboard.js v2.0.8
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory();
})(commonjsGlobal, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ clipboard; }
});

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(279);
var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
// EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
var listen = __webpack_require__(370);
var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
// EXTERNAL MODULE: ./node_modules/select/src/select.js
var src_select = __webpack_require__(817);
var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */

var ClipboardAction = /*#__PURE__*/function () {
  /**
   * @param {Object} options
   */
  function ClipboardAction(options) {
    _classCallCheck(this, ClipboardAction);

    this.resolveOptions(options);
    this.initSelection();
  }
  /**
   * Defines base properties passed from constructor.
   * @param {Object} options
   */


  _createClass(ClipboardAction, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = options.action;
      this.container = options.container;
      this.emitter = options.emitter;
      this.target = options.target;
      this.text = options.text;
      this.trigger = options.trigger;
      this.selectedText = '';
    }
    /**
     * Decides which selection strategy is going to be applied based
     * on the existence of `text` and `target` properties.
     */

  }, {
    key: "initSelection",
    value: function initSelection() {
      if (this.text) {
        this.selectFake();
      } else if (this.target) {
        this.selectTarget();
      }
    }
    /**
     * Creates a fake textarea element, sets its value from `text` property,
     */

  }, {
    key: "createFakeElement",
    value: function createFakeElement() {
      var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
      this.fakeElem = document.createElement('textarea'); // Prevent zooming on iOS

      this.fakeElem.style.fontSize = '12pt'; // Reset box model

      this.fakeElem.style.border = '0';
      this.fakeElem.style.padding = '0';
      this.fakeElem.style.margin = '0'; // Move element out of screen horizontally

      this.fakeElem.style.position = 'absolute';
      this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

      var yPosition = window.pageYOffset || document.documentElement.scrollTop;
      this.fakeElem.style.top = "".concat(yPosition, "px");
      this.fakeElem.setAttribute('readonly', '');
      this.fakeElem.value = this.text;
      return this.fakeElem;
    }
    /**
     * Get's the value of fakeElem,
     * and makes a selection on it.
     */

  }, {
    key: "selectFake",
    value: function selectFake() {
      var _this = this;

      var fakeElem = this.createFakeElement();

      this.fakeHandlerCallback = function () {
        return _this.removeFake();
      };

      this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
      this.container.appendChild(fakeElem);
      this.selectedText = select_default()(fakeElem);
      this.copyText();
      this.removeFake();
    }
    /**
     * Only removes the fake element after another click event, that way
     * a user can hit `Ctrl+C` to copy because selection still exists.
     */

  }, {
    key: "removeFake",
    value: function removeFake() {
      if (this.fakeHandler) {
        this.container.removeEventListener('click', this.fakeHandlerCallback);
        this.fakeHandler = null;
        this.fakeHandlerCallback = null;
      }

      if (this.fakeElem) {
        this.container.removeChild(this.fakeElem);
        this.fakeElem = null;
      }
    }
    /**
     * Selects the content from element passed on `target` property.
     */

  }, {
    key: "selectTarget",
    value: function selectTarget() {
      this.selectedText = select_default()(this.target);
      this.copyText();
    }
    /**
     * Executes the copy operation based on the current selection.
     */

  }, {
    key: "copyText",
    value: function copyText() {
      var succeeded;

      try {
        succeeded = document.execCommand(this.action);
      } catch (err) {
        succeeded = false;
      }

      this.handleResult(succeeded);
    }
    /**
     * Fires an event based on the copy operation result.
     * @param {Boolean} succeeded
     */

  }, {
    key: "handleResult",
    value: function handleResult(succeeded) {
      this.emitter.emit(succeeded ? 'success' : 'error', {
        action: this.action,
        text: this.selectedText,
        trigger: this.trigger,
        clearSelection: this.clearSelection.bind(this)
      });
    }
    /**
     * Moves focus away from `target` and back to the trigger, removes current selection.
     */

  }, {
    key: "clearSelection",
    value: function clearSelection() {
      if (this.trigger) {
        this.trigger.focus();
      }

      document.activeElement.blur();
      window.getSelection().removeAllRanges();
    }
    /**
     * Sets the `action` to be performed which can be either 'copy' or 'cut'.
     * @param {String} action
     */

  }, {
    key: "destroy",

    /**
     * Destroy lifecycle.
     */
    value: function destroy() {
      this.removeFake();
    }
  }, {
    key: "action",
    set: function set() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
      this._action = action;

      if (this._action !== 'copy' && this._action !== 'cut') {
        throw new Error('Invalid "action" value, use either "copy" or "cut"');
      }
    }
    /**
     * Gets the `action` property.
     * @return {String}
     */
    ,
    get: function get() {
      return this._action;
    }
    /**
     * Sets the `target` property using an element
     * that will be have its content copied.
     * @param {Element} target
     */

  }, {
    key: "target",
    set: function set(target) {
      if (target !== undefined) {
        if (target && _typeof(target) === 'object' && target.nodeType === 1) {
          if (this.action === 'copy' && target.hasAttribute('disabled')) {
            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
          }

          if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
          }

          this._target = target;
        } else {
          throw new Error('Invalid "target" value, use a valid Element');
        }
      }
    }
    /**
     * Gets the `target` property.
     * @return {String|HTMLElement}
     */
    ,
    get: function get() {
      return this._target;
    }
  }]);

  return ClipboardAction;
}();

/* harmony default export */ var clipboard_action = (ClipboardAction);
function clipboard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboard_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboard_typeof(obj); }

function clipboard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function clipboard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function clipboard_createClass(Constructor, protoProps, staticProps) { if (protoProps) clipboard_defineProperties(Constructor.prototype, protoProps); if (staticProps) clipboard_defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }




/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */

function getAttributeValue(suffix, element) {
  var attribute = "data-clipboard-".concat(suffix);

  if (!element.hasAttribute(attribute)) {
    return;
  }

  return element.getAttribute(attribute);
}
/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */


var Clipboard = /*#__PURE__*/function (_Emitter) {
  _inherits(Clipboard, _Emitter);

  var _super = _createSuper(Clipboard);

  /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */
  function Clipboard(trigger, options) {
    var _this;

    clipboard_classCallCheck(this, Clipboard);

    _this = _super.call(this);

    _this.resolveOptions(options);

    _this.listenClick(trigger);

    return _this;
  }
  /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */


  clipboard_createClass(Clipboard, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
      this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
      this.text = typeof options.text === 'function' ? options.text : this.defaultText;
      this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
    }
    /**
     * Adds a click event listener to the passed trigger.
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     */

  }, {
    key: "listenClick",
    value: function listenClick(trigger) {
      var _this2 = this;

      this.listener = listen_default()(trigger, 'click', function (e) {
        return _this2.onClick(e);
      });
    }
    /**
     * Defines a new `ClipboardAction` on each click event.
     * @param {Event} e
     */

  }, {
    key: "onClick",
    value: function onClick(e) {
      var trigger = e.delegateTarget || e.currentTarget;

      if (this.clipboardAction) {
        this.clipboardAction = null;
      }

      this.clipboardAction = new clipboard_action({
        action: this.action(trigger),
        target: this.target(trigger),
        text: this.text(trigger),
        container: this.container,
        trigger: trigger,
        emitter: this
      });
    }
    /**
     * Default `action` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultAction",
    value: function defaultAction(trigger) {
      return getAttributeValue('action', trigger);
    }
    /**
     * Default `target` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultTarget",
    value: function defaultTarget(trigger) {
      var selector = getAttributeValue('target', trigger);

      if (selector) {
        return document.querySelector(selector);
      }
    }
    /**
     * Returns the support of the given action, or all actions if no action is
     * given.
     * @param {String} [action]
     */

  }, {
    key: "defaultText",

    /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */
    value: function defaultText(trigger) {
      return getAttributeValue('text', trigger);
    }
    /**
     * Destroy lifecycle.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.listener.destroy();

      if (this.clipboardAction) {
        this.clipboardAction.destroy();
        this.clipboardAction = null;
      }
    }
  }], [{
    key: "isSupported",
    value: function isSupported() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
      var actions = typeof action === 'string' ? [action] : action;
      var support = !!document.queryCommandSupported;
      actions.forEach(function (action) {
        support = support && !!document.queryCommandSupported(action);
      });
      return support;
    }
  }]);

  return Clipboard;
}((tiny_emitter_default()));

/* harmony default export */ var clipboard = (Clipboard);

/***/ }),

/***/ 828:
/***/ (function(module) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ 438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var closest = __webpack_require__(828);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ 879:
/***/ (function(__unused_webpack_module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ 370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var is = __webpack_require__(879);
var delegate = __webpack_require__(438);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ 817:
/***/ (function(module) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ 279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    }
    listener._ = callback;
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); };
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(134);
/******/ })()
.default;
});
});

const ClipboardJS = /*@__PURE__*/getDefaultExportFromCjs(clipboard);

const COPY_LINK_DISABLED_PAGES = [
  /\/shop\/\w{2}\/\w{2}\/payment\/CheckoutOrderReview\.jsp/gi,
  /\/shop\/\w{2}\/\w{2}\/order\/orderConfirmation\.jsp/gi,
];
const API_COPY_LINK_CONFIG_URL = '/rest/model/schneider/chatlink/rest/CopyLinkActor/copyLink';
const COPY_LINK_BTN = 'copyBtn';
const CSC_ID = 'Chat_CSC_ID';

const agentLinkCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}@media screen and (min-width: 720px){:host(:not([dir=\"rtl\"])){padding-right:24px}:host([dir=\"rtl\"]){padding-left:24px}}.copy-link-button-wrapper{position:relative}.copy-link-button-wrapper__no-bar{margin-bottom:12px}.copy-link-button-wrapper .copy-link-button{width:48px;height:48px;border:none;background-color:#42b4e6;display:flex;justify-content:center;align-items:center;padding:0;box-shadow:0 0 2px 0 rgba(51, 51, 51, 0.14), 0 3px 5px 0 rgba(51, 51, 51, 0.1)}.copy-link-button-wrapper .copy-link-button:focus,.copy-link-button-wrapper .copy-link-button:hover{outline:0;padding:0}:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper .copy-link-button:focus,:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper .copy-link-button:hover{background:linear-gradient(180deg, #55d1fe 0%, #42b4e6 100%)}:host([dir=\"rtl\"]) .copy-link-button-wrapper .copy-link-button:focus,:host([dir=\"rtl\"]) .copy-link-button-wrapper .copy-link-button:hover{background:linear-gradient(-180deg, #55d1fe 0%, #42b4e6 100%)}.copy-link-button-wrapper.online .copy-link-button{background:#3dcd58}@media screen and (min-width: 720px){:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper.online .copy-link-button:hover{background:linear-gradient(180deg, #55d1fe 0%, #42b4e6 100%)}:host([dir=\"rtl\"]) .copy-link-button-wrapper.online .copy-link-button:hover{background:linear-gradient(-180deg, #55d1fe 0%, #42b4e6 100%)}}.copy-link-button-wrapper .copy-link-button:hover+.tooltip{display:block}.copy-link-button-wrapper.online .tooltip .availability span{color:#3dcd58}.copy-link-button-wrapper .tooltip{display:none;position:absolute;bottom:-4px;width:204px;padding:20px;background-color:#ffffff;box-shadow:0 0 5px 0 rgba(51, 51, 51, 0.05), 0 5px 5px 0 rgba(51, 51, 51, 0.15);font-family:\"ArialRoundedMTforSE_Latin\", Arial, \"Helvetica Neue\", Helvetica, sans-serif;font-display:swap;text-transform:none;color:#626469;font-size:0.75rem;line-height:1.125rem;border-radius:4px}:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper .tooltip{right:65px;text-align:left}:host([dir=\"rtl\"]) .copy-link-button-wrapper .tooltip{left:65px;text-align:right}.copy-link-button-wrapper .tooltip:after{content:\"\";position:absolute;bottom:24px;width:9px;height:9px;background-color:#ffffff}:host(:not([dir=\"rtl\"])) .copy-link-button-wrapper .tooltip:after{right:-5px;transform:rotate(225deg);box-shadow:-9px 2px 8px 0 rgba(0, 0, 0, 0.08)}:host([dir=\"rtl\"]) .copy-link-button-wrapper .tooltip:after{left:-5px;transform:rotate(-225deg);box-shadow:9px 2px 8px 0 rgba(0, 0, 0, 0.08)}@media screen and (max-width: 719px){.copy-link-button-wrapper{display:none}}";

function isBtnEnabledForPage() {
  return !COPY_LINK_DISABLED_PAGES.find((urlRx) => !!window.location.pathname.match(urlRx));
}
let CopyLinkButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.compareBar = false;
    this.state = {
      isDesktop: true,
      showTopBar: false,
      stickyAreaHeight: null,
      btnEnabled: isBtnEnabledForPage(),
      isLinkUpdated: false,
      config: {},
      labels: {},
    };
    this.handleCloseTopBar = () => {
      this.state = Object.assign(Object.assign({}, this.state), { showTopBar: false });
    };
    this.getCSCID = () => {
      var _a;
      const queryString = (_a = this.state.config) === null || _a === void 0 ? void 0 : _a.linkToShare.split('?')[1];
      const queries = queryString ? queryString.split('&') : null;
      if (queries) {
        for (let i = 0; i < queries.length; i++) {
          const query = queries[i].split('=');
          if (query[0] === CSC_ID) {
            return query[1];
          }
        }
      }
    };
    this.updateLinkToShare = () => {
      const CSCValue = this.getCSCID();
      return window.location.search
        ? `${window.location.href}&${CSC_ID}=${CSCValue}`
        : `${window.location.href}?${CSC_ID}=${CSCValue}`;
    };
    this.handleBtnClick = (e) => {
      e.preventDefault();
      let linkToShare;
      if (this.state.config.linkToShare
        && this.state.config.linkToShare.split('?')[0]
          !== `${window.location.origin}+${window.location.pathname}`) {
        linkToShare = this.updateLinkToShare();
      }
      document.addEventListener('mousedown', this.handleClickOutside);
      const updatedState = linkToShare
        ? {
          showTopBar: true,
          config: Object.assign(Object.assign({}, this.state.config), { linkToShare }),
          isLinkUpdated: true,
        }
        : {
          showTopBar: true,
          isLinkUpdated: true,
        };
      this.state = Object.assign(Object.assign({}, this.state), updatedState);
      const { prepareQuoteRest } = this.state.config;
      if (prepareQuoteRest) {
        this.prepareQuoteRestRequest(prepareQuoteRest);
      }
    };
    this.handlePDPHeaderChangeEvent = (e) => {
      this.state = Object.assign(Object.assign({}, this.state), { stickyAreaHeight: e.detail.stickyAreaHeight });
    };
    this.setButtonRef = (node) => {
      this.buttonRef = node;
    };
    this.setHostRef = (node) => {
      this.hostRef = node;
    };
    this.hideTopBar = () => {
      this.state = Object.assign(Object.assign({}, this.state), { showTopBar: false });
      document.removeEventListener('mousedown', this.handleClickOutside);
    };
    this.handleClickOutside = (event) => {
      if (this.notificationController.getBannerElement().contains(event.target)) {
        return;
      }
      if (this.hostRef !== event.target) {
        this.hideTopBar();
      }
    };
  }
  handleStateUpdate(_, oldState) {
    var _a, _b, _c, _d;
    if (this.state.showTopBar !== oldState.showTopBar) {
      if (this.state.showTopBar) {
        this.notificationController = new NotificationBannerController();
        this.notificationController.show({
          target: ((_a = this.state.config) === null || _a === void 0 ? void 0 : _a.noHeader) ? 'body' : 'header',
          componentProps: {
            active: true,
            status: "informational",
            innerHTML: `
              <div>
                ${IconCopy}
                &nbsp;${(_b = this.state.labels) === null || _b === void 0 ? void 0 : _b.message}
                <a
                  href="${(_c = this.state.config) === null || _c === void 0 ? void 0 : _c.linkToShare}"
                  target="_blank"
                  style="color: #ffffff; text-decoration: underline"
                >${(_d = this.state.labels) === null || _d === void 0 ? void 0 : _d.target}</a>
              </div>`,
          },
        });
        document.addEventListener('closeDidClick', this.hideTopBar);
      }
      else {
        const bannerEl = this.notificationController.getBannerElement();
        bannerEl.dispatchEvent(new CustomEvent('closeDidClick'));
        document.removeEventListener('closeDidClick', this.hideTopBar);
      }
    }
  }
  prepareQuoteRestRequest(prepareQuoteRest) {
    fetch(prepareQuoteRest)
      .then(() => {
      console.log('success');
    })
      .catch((error) => {
      console.log(error);
    });
  }
  request(url) {
    return fetch(url, {
      credentials: 'include',
    }).then((response) => {
      if (response.status === 200)
        return response.json();
      throw response.status;
    });
  }
  loadConfig(host) {
    this.request(`${host}${API_COPY_LINK_CONFIG_URL}`)
      .then((config) => {
      if (config) {
        this.state = Object.assign(Object.assign({}, this.state), { config });
      }
    })
      .catch((error) => {
      console.error(error);
    });
  }
  componentDidLoad() {
    const locale = document.querySelector('body').getAttribute('locale');
    const [languageCode, contryCode] = locale.split('_');
    const brand = getBrandName();
    let url = `${this.host}/product/api/agent/link`;
    if (isV3()) {
      url = `/agent/link?country-code=${contryCode}&language-code=${languageCode}&brand=${brand}`;
    }
    if (this.state.btnEnabled) {
      this.request(url)
        .then(({ labels, urls }) => {
        this.state = Object.assign(Object.assign({}, this.state), { labels });
        this.loadConfig(urls.apcHost);
      })
        .catch((error) => {
        console.error(error);
      });
    }
    if (this.buttonRef) {
      new ClipboardJS(this.buttonRef);
    }
  }
  disconnectedCallback() {
    const clipboard = new ClipboardJS(this.buttonRef);
    clipboard.destroy();
  }
  componentDidUpdate() {
    if (this.state.isLinkUpdated) {
      new ClipboardJS(this.buttonRef);
      this.state = Object.assign(Object.assign({}, this.state), { isLinkUpdated: false });
    }
  }
  render() {
    var _a;
    const { config } = this.state;
    if (!config.linkToShare) {
      return null;
    }
    return (h(Host, { ref: this.setHostRef }, h("div", { class: classnames('copy-link-button-wrapper', {
        'copy-link-button-wrapper__no-bar': !this.compareBar,
      }) }, h("button", { class: "copy-link-button", "aria-label": "", onClick: this.handleBtnClick, "data-clipboard-text": config.linkToShare, "data-clipboard-action": "copy", id: COPY_LINK_BTN, ref: this.setButtonRef }, h("div", { innerHTML: IconCopy })), h("div", { class: "tooltip" }, (_a = this.state.labels) === null || _a === void 0 ? void 0 : _a.tooltip))));
  }
  static get watchers() { return {
    "state": ["handleStateUpdate"]
  }; }
};
CopyLinkButton.style = agentLinkCss;

export { CopyLinkButton as pes_agent_link };
